import { Color } from '@tiptap/extension-color';
import CustomImage from '@/components/composer/utils/custom-image.js';
import FontFamily from '@tiptap/extension-font-family';
import Table from '@tiptap/extension-table';
import TableCell from '@tiptap/extension-table-cell';
import TableHeader from '@tiptap/extension-table-header';
import TableRow from '@tiptap/extension-table-row';

export { default as CharacterCount } from '@tiptap/extension-character-count';
export { default as Highlight } from '@tiptap/extension-highlight';
export { default as Image } from '@tiptap/extension-image';
export { default as Link } from '@tiptap/extension-link';
export { default as StarterKit } from '@tiptap/starter-kit';
export { default as TextAlign } from '@tiptap/extension-text-align';
export { default as TextStyle } from '@tiptap/extension-text-style';
export { default as Underline } from '@tiptap/extension-underline';

export const CustomColorBg = Color.extend({
    name: 'customColorBg',
    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    backgroundColor: {
                        default: null,
                        parseHTML: (element) => element.style.backgroundColor.replace(/['"]+/g, ''),
                        renderHTML: (attributes) => {
                            if (!attributes.backgroundColor) {
                                return {};
                            }

                            return {
                                style: `background-color: ${attributes.backgroundColor}`,
                            };
                        },
                    },
                },
            },
        ];
    },

    addCommands() {
        return {
            setBgColor:
                (backgroundColor) =>
                ({ chain }) => {
                    return chain().setMark('textStyle', { backgroundColor }).run();
                },
            unsetBgColor:
                () =>
                ({ chain }) => {
                    return chain()
                        .setMark('textStyle', { backgroundColor: null })
                        .removeEmptyTextStyle()
                        .run();
                },
        };
    },
});

export const CustomFontSize = FontFamily.extend({
    name: 'customFontSize',
    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    fontSize: {
                        default: null,
                        parseHTML: (element) => element.style.fontSize.replace(/['"]+/g, ''),
                        renderHTML: (attributes) => {
                            if (!attributes.fontSize) {
                                return {};
                            }

                            return {
                                style: `font-size: ${attributes.fontSize}`,
                            };
                        },
                    },
                },
            },
        ];
    },

    addCommands() {
        return {
            setFontSize:
                (fontSize) =>
                ({ chain }) => {
                    return chain().setMark('textStyle', { fontSize }).run();
                },
            unsetFontSize:
                () =>
                ({ chain }) => {
                    return chain()
                        .setMark('textStyle', { fontSize: null })
                        .removeEmptyTextStyle()
                        .run();
                },
        };
    },
});

export { Color, CustomImage, FontFamily };

const styleAttribute = {
    style: {
        default: null,
        parseHTML: (element) => element.getAttribute('style') || null,
        renderHTML: (attributes) => (attributes.style ? { style: attributes.style } : {}),
    },
};

const vehicleBrochureAttributes = {
    'data-vehicle-brochure': {
        default: null,
        parseHTML: (element) => element.dataset.vehicleBrochure || null,
        renderHTML: (attributes) => {
            const value = attributes['data-vehicle-brochure'];

            return value ? { 'data-vehicle-brochure': value } : {};
        },
    },
    'data-vehicle-brochure-root': {
        default: null,
        parseHTML: (element) => element.dataset.vehicleBrochureRoot || null,
        renderHTML: (attributes) => {
            const value = attributes['data-vehicle-brochure-root'];

            return value ? { 'data-vehicle-brochure-root': value } : {};
        },
    },
};

const extendWithStyle = (Extension) =>
    Extension.extend({
        addAttributes() {
            return {
                ...this.parent?.(),
                ...styleAttribute,
            };
        },
    });

export const StyledTable = Table.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            ...styleAttribute,
            ...vehicleBrochureAttributes,
        };
    },
});
export const StyledTableCell = extendWithStyle(TableCell);
export const StyledTableHeader = extendWithStyle(TableHeader);
export const StyledTableRow = extendWithStyle(TableRow);
